export default {
  plural: 'Evaluation Sets',
  searchByProjectName: 'Search evaluation sets by project name',
  states: {
    canceled: 'Canceled',
    done: 'Done',
    waiting: 'Waiting'
  }
};
